import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * OpenHouses — the "Open houses" block (BR-112): one row per upcoming open house, a dated window
 * in the listing's own timezone, plus how to arrange a private showing. Informational only: a
 * prospect cannot RSVP from the page (KG-22-2), so there is no control here. Renders nothing when
 * the listing has no upcoming open houses (BR-PL-03).
 */
import { asIsoDateTimeString, formatTimestamp } from '@resida/shared';
function viewerTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function formatDay(iso, timezone) {
    return formatTimestamp(asIsoDateTimeString(iso), timezone, {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
    });
}
function formatClock(iso, timezone) {
    return formatTimestamp(asIsoDateTimeString(iso), timezone, {
        hour: 'numeric',
        minute: '2-digit',
    }).toLowerCase();
}
function HouseIcon() {
    return (_jsx("svg", { className: "w-4 h-4 text-primary shrink-0", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: 2, "aria-hidden": "true", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" }) }));
}
export function OpenHouses({ openHouses, timezone }) {
    if (openHouses.length === 0)
        return null;
    const zone = timezone ?? viewerTimezone();
    return (_jsxs("section", { "data-testid": "listing-open-houses", className: "bg-card rounded-lg border border-border p-5", "aria-labelledby": "listing-open-houses-heading", children: [_jsxs("h2", { id: "listing-open-houses-heading", className: "text-sm font-semibold text-foreground mb-3 flex items-center gap-1.5", children: [_jsx(HouseIcon, {}), "Open houses"] }), _jsx("ul", { className: "space-y-2 text-sm list-none p-0 m-0", children: openHouses.map((house) => (_jsxs("li", { "data-testid": "listing-open-house", className: "flex flex-wrap justify-between gap-x-4 gap-y-1", children: [_jsx("span", { className: "text-foreground font-medium", children: formatDay(house.startsAt, zone) }), _jsxs("span", { className: "text-muted-foreground", children: [formatClock(house.startsAt, zone), " \u2013 ", formatClock(house.endsAt, zone)] })] }, `${house.startsAt}-${house.endsAt}`))) }), _jsx("p", { className: "text-xs text-muted-foreground mt-3", children: "Drop by during these times. To arrange a private showing, contact the landlord." })] }));
}
//# sourceMappingURL=OpenHouses.js.map